function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "infographic-hi-dark_svg__a",
  "data-name": "Infographics_ic_hi",
  viewBox: "0 0 191.5 191.5"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 191.5V0h191.5v191.5H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.71 95.84L167 132.12a79.88 79.88 0 01-14.7 20.23L95.71 95.84",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.71 95.84l56.54 56.5A79.88 79.88 0 00167 132.12L95.71 95.84",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.71 95.84l79.36-9.74a76 76 0 01-8.12 46z",
  fill: "#4a4d4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.71 95.84l20.69-77.19c32.46 8.69 54.6 34.12 58.67 67.45z",
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.71 95.84l56.54 56.51a79.93 79.93 0 01-113.08-113C60 18.55 88 11 116.4 18.65z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.75 173.87a80 80 0 01-80-79v1a80 80 0 00160 0v-1a80 80 0 01-80 79z",
  opacity: 0.06
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Infographic_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Infographics_ic_hi",
  width: 191.5,
  height: 191.5,
  transform: "translate(.25 .25)",
  xlinkHref: "#infographic-hi-dark_svg__a"
}));

var SvgInfographicHiDark = function SvgInfographicHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgInfographicHiDark;